import MyAssets from './myAssets';

export default MyAssets;



// WEBPACK FOOTER //
// ./src/components/widgets/myAssets/index.js